const MODULE_BASE = `${process.env.REACT_APP_PATH_MAP_BASE}/cal-sco/ecommerce`

const ECOMMERCE_LABEL_PATH = `${MODULE_BASE}/label`;

const pathMap = {
    //Label
    LABEL_PAGE: ECOMMERCE_LABEL_PATH,
}

export default pathMap